export default "__VITE_ASSET__CdJv7EGn__"